import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import CheckboxField from '../../../FormLegacy/FormFieldsV2/CheckboxField'
import API from '../../../../api/api'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'

const NotifyModal = ({ isOpen, handleClose, id }) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const { displaySnackbar } = useSnackbar()
  const [call, setCall] = useState(false)
  const [email, setEmail] = useState(false)
  const [push, setPush] = useState(false)
  const [sms, setSms] = useState(false)
  const notifyUser = () => {
    API.notifyAssignee({ call, email, push, sms }, id)
      .then(() => displaySnackbar(t('maintenance:requestPreview.notifyModal.success')))
      .catch(() => displaySnackbar(t('maintenance:requestPreview.notifyModal.error'), true))
      .finally(() => {
        setCall(false)
        setEmail(false)
        setPush(false)
        setSms(false)
        handleClose()
      })
  }
  return (
    <ModalContainer
      onClose={handleClose}
      isVisible={isOpen}
      headerTitle={t('maintenance:requestPreview.notifyModal.title')}
    >
      <div className="notify-modal">
        <div className="notify-modal-notifications">
          <p className="notify-modal-text">
            {t('maintenance:requestPreview.notifyModal.description')}
          </p>
          <CheckboxField
            name="call"
            value={call}
            onChange={() => setCall((prev) => !prev)}
            label={t('maintenance:requestPreview.notifyModal.methods.call')}
          />
          <CheckboxField
            name="email"
            value={email}
            onChange={() => setEmail((prev) => !prev)}
            label={t('maintenance:requestPreview.notifyModal.methods.email')}
          />
          <CheckboxField
            name="push"
            value={push}
            onChange={() => setPush((prev) => !prev)}
            label={t('maintenance:requestPreview.notifyModal.methods.push')}
          />
          <CheckboxField
            name="sms"
            value={sms}
            onChange={() => setSms((prev) => !prev)}
            label={t('maintenance:requestPreview.notifyModal.methods.sms')}
          />
        </div>
        <div className="notify-modal-buttons">
          <button onClick={handleClose} className="button button-gray">
            {t('common:actions.cancel')}
          </button>
          <button onClick={notifyUser} className="button button-black">
            {t('maintenance:requestPreview.notifyModal.notify')}
          </button>
        </div>
      </div>
    </ModalContainer>
  )
}

NotifyModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  id: PropTypes.number,
}

export default NotifyModal
